import messages from '@intlify/unplugin-vue-i18n/messages';
import { createI18n } from 'vue-i18n';
import { numberFormats } from './i18n/numberFormats';
import { datetimeFormats } from './i18n/datetimeFormats';

export const AVAILABLE_LOCALES = ['en-US', 'de-DE'];

export const i18n = createI18n({
  legacy: false,
  locale: navigator.languages.find((locale) => AVAILABLE_LOCALES.includes(locale)) || 'en-US',
  messages,
  numberFormats,
  datetimeFormats,
});
